import React from "react";
import { Link } from "react-router-dom";
import {
  SectionThree,
  SectionThreeInner,
  SectionThreeGrid,
  SectionThreeText,
  WarningRow,
  WarningMark,
  WarningTitle,
  BulletList,
  BulletItem,
  SectionThreeCta,
  SectionThreeVisualColumn,
  SectionThreeVisual,
  RectangleBack,
  ForegroundImage,
  PalmTitle,
} from "./styles";

export default function SectionThreeComponent() {
  return (
    <SectionThree>
      <SectionThreeInner>
        <SectionThreeGrid>
          <SectionThreeText>
            <WarningRow>
              <WarningMark>!</WarningMark>
              <div>
                <WarningTitle>
                  <strong>O problema</strong> não está
                  <br />
                  na consulta
                  <br />
                  está no que
                  <br />
                  <strong>acontece depois</strong>
                </WarningTitle>

                <BulletList>
                  <BulletItem>PACIENTE ESQUECE</BulletItem>
                  <BulletItem>NÃO EXECUTA CORRETAMENTE</BulletItem>
                  <BulletItem>PERDE CONTINUIDADE</BulletItem>
                  <BulletItem>ABANDONA TRATAMENTO</BulletItem>
                </BulletList>

                <SectionThreeCta
                  as={Link}
                  to="https://www.trataz.com.br/login"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  TESTE JÁ COM SEUS PACIENTES
                </SectionThreeCta>
              </div>
            </WarningRow>
          </SectionThreeText>

          <SectionThreeVisualColumn>
            <SectionThreeVisual>
              <RectangleBack />
              <ForegroundImage
                src="/novas-imagens/section-three/image.png"
                alt="Paciente e profissional usando a plataforma"
              />
            </SectionThreeVisual>
            <PalmTitle>SEU CONSULTÓRIO NA PALMA DA MÃO</PalmTitle>
          </SectionThreeVisualColumn>
        </SectionThreeGrid>
      </SectionThreeInner>
    </SectionThree>
  );
}
